import React from 'react';
import { Typography } from '@mui/material';

import styles from './Thumbnails.module.css'
import { Link, useParams } from 'react-router-dom';
import ImageWrapper from '../common/ImageWrapper';

interface WideImageProps {
  img: string;
  text: string;
  id: string;
  type: string;
  height?: string;
  status?: string;
}

const WideImage: React.FC<WideImageProps> = ({ img, text, id, type, height, status }) => {
    const {slug} = useParams()

    return (
            <Link style={{height, 
                pointerEvents: status && status !== "published"? 'none' : undefined,
                opacity: status === 'Published-Inactive'? '40%' : '',
            }}
                className={`${styles['wide-image']} thumbnail`}
                to={`/${slug}/${id}`}
            >
                <ImageWrapper img={img} hasOverlay={true} />
                <Typography
                    component='div'
                    variant='body1'
                    sx={{
                        position: 'relative',
                        bottom: '25%',
                        padding: '0 8px',
                        width: '95%'
                    }}
                >{text}</Typography>
            </Link>
    );
};

export default WideImage;
